import * as angular from 'angular';

import * as Fields from '../../../common/helpers/contextual';
import { ComponentDefinition, ContextualField } from '../../../models/';
import { BusinessKpiConfiguration } from '../businessKpi.configuration';


class BusinessKpiContextualController implements angular.IComponentController {
    isLoading: boolean;
    loadingMessage: string;
    properties: ContextualField[];
    configuration: BusinessKpiConfiguration;
    save: () => void;
    cancel: () => void;

    private _originalConfiguration: BusinessKpiConfiguration;

    static $inject = ['$q'];

    constructor(private _$q: angular.IQService) {
    }

    $onInit() {
        this.isLoading = true;

        this._originalConfiguration = angular.copy(this.configuration);
        this.initProperties();

        this.isLoading = false;
    }

    onSave(): angular.IPromise<void> {
        return this._$q.when(this.save());
    }

    onCancel() {
        this.configuration = angular.copy(this._originalConfiguration);
        this.cancel();
    }

    private initProperties() {
        if(this.configuration.alignedOn === undefined){
            this.configuration.alignedOn = 0;
        }
        const aggregationMode = angular.copy(Fields.AggregationMode);
        delete aggregationMode.extraData.subProperty;
        aggregationMode.modelName = 'aggregationMode';

        const prop: ContextualField[] = [
            aggregationMode,
            angular.copy(Fields.MinPeriod),
            angular.copy(Fields.MaxPeriod),
            angular.copy(Fields.PeriodReference),
            angular.copy(Fields.IsEndDateIncluded),
            angular.copy(Fields.NameConfiguration.HasGroupName),
            angular.copy(Fields.NameConfiguration.HasName),
            angular.copy(Fields.NameConfiguration.HasShortComment),
            angular.copy(Fields.NameConfiguration.HasUnit),
            angular.copy(Fields.NameConfiguration.HasValueType)
        ];

        this.properties = prop;
    }
}

export const wtBusinessKpiContextual: ComponentDefinition = {
    componentId: 'wtBusinessKpiContextual',
    controller: BusinessKpiContextualController,
    template: require('./businessKpiContextual.component.html'),
    controllerAs: 'vm',
    bindings: {
        formController: '=',
        configuration: '=',
        save: '&?',
        cancel: '&?'
    }
};